import React, { useState } from 'react';
import { Mail, Phone, MapPin, Send, MessageCircle } from 'lucide-react';

const ContactUsPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    alert('تم إرسال رسالتك بنجاح!');
    setFormData({ name: '', email: '', message: '' });
  };

  const contactInfo = [
    { icon: <Phone className="h-6 w-6" />, title: 'اتصل بنا', value: '+966 11 123 4567' },
    { icon: <Mail className="h-6 w-6" />, title: 'راسلنا عبر البريد', value: 'Rayanpharmacy@gmail.com' },
    { icon: <MapPin className="h-6 w-6" />, title: 'موقعنا', value: 'طريق الملك فهد، الرياض، المملكة العربية السعودية' }
  ];

  return (
    <section id="contact" className="bg-gray-50 py-16 font-['Cairo'] lg:py-24">
      <div className="container mx-auto px-4">
        <div className="mb-12 text-center">
          <div className="mb-4 flex items-center justify-center gap-2">
            <MessageCircle className="h-6 w-6 text-[#10B981]" />
            <span className="font-semibold text-[#10B981]">تواصل معنا</span>
          </div>
          <h2 className="mb-4 text-3xl font-bold text-gray-900 lg:text-4xl">نحن هنا لمساعدتك</h2>
          <p className="mx-auto max-w-2xl text-lg text-gray-600">
            سواء كان لديك سؤال، تعليق، أو استفسار طبي، فريقنا متاح لتقديم الدعم اللازم. لا تتردد في التواصل معنا.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:gap-10">
          {/* قسم معلومات الاتصال */}
          <div className="flex flex-col justify-between rounded-2xl bg-white p-8 shadow-md ring-1 ring-gray-100 lg:p-10">
            <div className="mb-8 space-y-6">
              {contactInfo.map((info, index) => (
                <div
                  key={index}
                  className="group flex items-start gap-4 rounded-xl p-2 transition-colors duration-200 hover:bg-[#10B981]/5"
                >
                  <div className="flex-shrink-0 rounded-full bg-[#10B981]/10 p-4 text-[#10B981] transition-transform duration-300 group-hover:scale-105">
                    {info.icon}
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-900">{info.title}</h3>
                    <p className="mt-1 leading-relaxed text-gray-600">{info.value}</p>
                  </div>
                </div>
              ))}
            </div>
            {/* خريطة جوجل مابس */}
            <div className="mt-8 h-64 overflow-hidden rounded-xl ring-1 ring-gray-200">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3621.127381111125!2d46.61203897536977!3d24.825317077952178!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e2f1b5ab2e599c1%3A0x58ab1ee4e94e9c89!2sKing%20Fahd%20Rd%2C%20Riyadh%20Saudi%20Arabia!5e0!3m2!1sen!2seg!4v1784380316810!5m2!1sen!2seg"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="strict-origin-when-cross-origin"
                title="موقعنا على الخريطة"
              ></iframe>
            </div>
          </div>

          {/* قسم نموذج الاتصال */}
          <div className="rounded-2xl bg-white p-8 shadow-md ring-1 ring-gray-100 lg:p-10">
            <h3 className="mb-6 text-2xl font-bold text-gray-900">أرسل لنا رسالة</h3>
            <form onSubmit={handleSubmit} className="space-y-5">
              <div>
                <label htmlFor="name" className="mb-1.5 block text-sm font-semibold text-gray-700">
                  الاسم الكامل
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className="w-full rounded-xl border-2 border-gray-200 px-4 py-3 outline-none transition-colors duration-200 focus:border-[#10B981]"
                  required
                />
              </div>
              <div>
                <label htmlFor="email" className="mb-1.5 block text-sm font-semibold text-gray-700">
                  البريد الإلكتروني
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full rounded-xl border-2 border-gray-200 px-4 py-3 outline-none transition-colors duration-200 focus:border-[#10B981]"
                  required
                />
              </div>
              <div>
                <label htmlFor="message" className="mb-1.5 block text-sm font-semibold text-gray-700">
                  رسالتك
                </label>
                <textarea
                  id="message"
                  name="message"
                  rows="4"
                  value={formData.message}
                  onChange={handleChange}
                  className="w-full resize-none rounded-xl border-2 border-gray-200 px-4 py-3 outline-none transition-colors duration-200 focus:border-[#10B981]"
                  required
                ></textarea>
              </div>
              <button
                type="submit"
                className="flex w-full items-center justify-center gap-2 rounded-xl bg-[#10B981] py-3.5 font-bold text-white shadow-sm shadow-[#10B981]/20 transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#0ea173] hover:shadow-lg hover:shadow-[#10B981]/25 active:translate-y-0"
              >
                <Send className="h-5 w-5" />
                إرسال الرسالة
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactUsPage;
